import { render, staticRenderFns } from "./edit_lecture.vue?vue&type=template&id=ee508384&scoped=true&"
import script from "./edit_lecture.vue?vue&type=script&lang=js&"
export * from "./edit_lecture.vue?vue&type=script&lang=js&"
import style0 from "./edit_lecture.vue?vue&type=style&index=0&id=ee508384&scoped=true&lang=css&"
import style1 from "./edit_lecture.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee508384",
  null
  
)

export default component.exports